import { vservice } from '@niknevis/vue-modules'
import EntitySearchService from '@/modules/common/entity-search/services/entity-search.service'
import { RemoteData } from '@/modules/shared/helpers/http/remote-data'
import { Paginated } from '@/modules/shared/models/data'
import { Paginatable } from '@/modules/shared/helpers/http/paginatable'

@vservice()
export class SearchEntityItemsPaginatedUseCase<T> {
  constructor(
    private readonly service: EntitySearchService<T>
  ) {
  }

  entitySearch(route, s, page, params?) {
    return RemoteData.fromPromise(
      this.service.entitySearch(route, s, page, params)
    )
  }

  execute(route: string, params?) {
    return new Paginatable<Paginated<T[]>>(
      (page, s) => this.entitySearch(route, s, page, params),
      (oldValue, newValue) => {
        if (oldValue.meta.current_page < newValue.meta.current_page) {
          return {
            ...newValue,
            data: oldValue.data.concat(newValue.data)
          }
        }
        return newValue
      }
    )
  }
}
